import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { reportBoundaryError } from '../app/bootstrap/reportBoundaryError';
import { shellContributions } from '../domains/_discover-shell';

// Lazy-loaded to keep domain barrels off the critical path; each gets its own boundary so one
// failing domain drops only its own banners/markers instead of crashing the shell (header included).
export function DomainShellContributions() {
  return (
    <>
      {shellContributions.map(([path, Component]) => (
        <ErrorBoundary
          key={path}
          fallback={null}
          onError={(error, info) => reportBoundaryError(error, 'shell-contribution', info.componentStack ?? undefined)}
        >
          <Suspense fallback={null}>
            <Component />
          </Suspense>
        </ErrorBoundary>
      ))}
    </>
  );
}
